import { SVGProps } from "react";

type TargetIconProps = SVGProps<SVGSVGElement> & {
  variant?: "default" | "orange" | "green";
  fill?: string;
};

export const TargetIcon = ({
  width = 18,
  height = 18,
  viewBox = "0 0 18 18",
  variant = "default",
  fill: customFill,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: TargetIconProps) => {
  const fill =
    customFill ??
    (variant === "orange"
      ? "#F79009"
      : variant === "green"
      ? "#008934"
      : "#667085");
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        strokeWidth={0}
        d="M8.16667 5.74997C8.58333 5.66663 8.91667 5.16663 8.75 4.74997C8.66667 4.3333 8.16667 3.99997 7.75 4.16663C5.5 4.66663 4 6.66663 4 8.99997C4 11.75 6.25 14 9 14C11.5833 14 13.75 12 14 9.41663C14.0833 8.99997 13.6667 8.5833 13.25 8.49997C12.8333 8.41663 12.4167 8.8333 12.3333 9.24997C12.1667 10.9166 10.6667 12.3333 9 12.3333C7.16667 12.3333 5.66667 10.8333 5.66667 8.99997C5.66667 7.41663 6.66667 6.0833 8.16667 5.74997Z"
        fill={fill}
      />
      <path
        strokeWidth={0}
        d="M16.5 8.16657C16 8.16657 15.6667 8.4999 15.6667 8.9999C15.6667 12.6666 12.6667 15.6666 9.00002 15.6666C5.33335 15.6666 2.33335 12.6666 2.33335 8.9999C2.33335 5.4999 5.08335 2.58324 8.58335 2.33324C9.08335 2.33324 9.41669 1.91657 9.33335 1.41657C9.33335 0.916571 8.91669 0.583237 8.41669 0.666571C4.08335 0.999904 0.666687 4.58324 0.666687 8.9999C0.666687 13.5832 4.41669 17.3332 9.00002 17.3332C13.5834 17.3332 17.3334 13.5832 17.3334 8.9999C17.3334 8.4999 16.9167 8.16657 16.5 8.16657Z"
        fill={fill}
      />
      <path
        strokeWidth={0}
        d="M10.5834 6.24996L8.41669 8.41663C8.08335 8.74996 8.08335 9.24996 8.41669 9.58329C8.58335 9.74996 8.83335 9.83329 9.00002 9.83329C9.16669 9.83329 9.41669 9.74996 9.58335 9.58329L11.75 7.41663L13.1667 7.83329C13.25 7.83329 13.3334 7.83329 13.4167 7.83329C13.6667 7.83329 13.8334 7.74996 14 7.58329L17.25 4.24996C17.4167 4.08329 17.5 3.74996 17.5 3.49996C17.5 3.24996 17.25 2.99996 17 2.91663L15.5 2.41663L15 0.916626C14.9167 0.666626 14.6667 0.416626 14.4167 0.416626C14.1667 0.333293 13.8334 0.416626 13.6667 0.666626L10.4167 3.99996C10.1667 4.24996 10.0834 4.58329 10.25 4.83329L10.5834 6.24996ZM13.8334 2.83329L14.0834 3.41663C14.1667 3.66663 14.3334 3.83329 14.5834 3.91663L15.1667 4.16663L13.1667 6.16663L12.1667 5.83329L11.8334 4.83329L13.8334 2.83329Z"
        fill={fill}
      />
    </svg>
  );
};

export const SmTargetIcon = ({
  width = 20,
  height = 20,
  viewBox = "0 0 20 20",
  variant = "default",
  fill: customFill,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: TargetIconProps) => {
  const fill =
    customFill ??
    (variant === "orange"
      ? "#F79009"
      : variant === "green"
      ? "#008934"
      : "#667085");
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6024 1.66667 10 1.66667C5.39765 1.66667 1.66669 5.39763 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z"
        stroke={fill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15Z"
        stroke={fill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.6667C10.9205 11.6667 11.6667 10.9205 11.6667 10C11.6667 9.07953 10.9205 8.33334 10 8.33334C9.07953 8.33334 8.33337 9.07953 8.33337 10C8.33337 10.9205 9.07953 11.6667 10 11.6667Z"
        stroke={fill}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0834 7.24996L9.91669 9.41663C9.58335 9.74996 9.58335 10.25 9.91669 10.5833C10.0834 10.75 10.3334 10.8333 10.5 10.8333C10.6667 10.8333 10.9167 10.75 11.0834 10.5833L13.25 8.41663L14.6667 8.83329C14.75 8.83329 14.8334 8.83329 14.9167 8.83329C15.1667 8.83329 15.3334 8.74996 15.5 8.58329L18.75 5.24996C18.9167 5.08329 19 4.74996 19 4.49996C19 4.24996 18.75 3.99996 18.5 3.91663L17 3.41663L16.5 1.91663C16.4167 1.66663 16.1667 1.41663 15.9167 1.41663C15.6667 1.33329 15.3334 1.41663 15.1667 1.66663L11.9167 4.99996C11.6667 5.24996 11.5834 5.58329 11.75 5.83329L12.0834 7.24996ZM15.3334 3.83329L15.5834 4.41663C15.6667 4.66663 15.8334 4.83329 16.0834 4.91663L16.6667 5.16663L14.6667 7.16663L13.6667 6.83329L13.3334 5.83329L15.3334 3.83329Z"
        fill={fill}
      />
    </svg>
  );
};

export const LgTargetIcon = ({
  width = 40,
  height = 40,
  viewBox = "0 0 40 40",
  variant = "default",
  fill: customFill,
  xmlns = "http://www.w3.org/2000/svg",
  ...props
}: TargetIconProps) => {
  const fill =
    customFill ??
    (variant === "orange"
      ? "#F79009"
      : variant === "green"
      ? "#008934"
      : "#667085");
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns={xmlns}
      {...props}
    >
      <path
        d="M20 36.6667C29.2048 36.6667 36.6667 29.2048 36.6667 20C36.6667 10.7953 29.2048 3.33334 20 3.33334C10.7953 3.33334 3.33337 10.7953 3.33337 20C3.33337 29.2048 10.7953 36.6667 20 36.6667Z"
        stroke={fill}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
        stroke={fill}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 23.3333C21.8409 23.3333 23.3333 21.8409 23.3333 20C23.3333 18.1591 21.8409 16.6667 20 16.6667C18.1591 16.6667 16.6667 18.1591 16.6667 20C16.6667 21.8409 18.1591 23.3333 20 23.3333Z"
        stroke={fill}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1667 16.4999L21.8334 18.8333C21.4167 19.25 21.4167 19.9167 21.8334 20.3333C22.0834 20.5833 22.4167 20.75 22.6667 20.75C22.9167 20.75 23.25 20.5833 23.5 20.3333L25.8334 18L27.6667 18.5C27.8334 18.5 28 18.5 28.1667 18.5C28.5 18.5 28.75 18.3333 29 18.1667L33 14.1667C33.3334 13.8333 33.5 13.3333 33.5 12.8333C33.5 12.3333 33 11.8333 32.6667 11.6667L30.6667 10.8333L30 8.83333C29.8334 8.33333 29.3334 7.83333 28.8334 7.83333C28.3334 7.66667 27.6667 7.83333 27.3334 8.16667L23.3334 12.1667C22.8334 12.6667 22.6667 13.3333 22.8334 13.8333L24.1667 16.4999ZM30.6667 11.6667L31.1667 12.8333C31.3334 13.3333 31.6667 13.6667 32.1667 13.8333L33.3334 14.3333L30.6667 17L29.1667 16.5L28.6667 15.1667L30.6667 11.6667Z"
        fill={fill}
      />
    </svg>
  );
};
